var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.svgIcon)?_c('span',{staticClass:"svg-icon",class:[_vm.iconClass, { 'icon-disabled': _vm.disabled }],style:(_vm.svgIconStyle),domProps:{"innerHTML":_vm._s(_vm.svgIcon)},on:{"click":_vm.onClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }